import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

type LoadingIndicatorProps = React.SVGProps<SVGSVGElement>;

export const LoadingIndicator = ({
  className,
  ...props
}: LoadingIndicatorProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-loading-indicator');

  return (
    <svg className={classNames} viewBox="0 0 64 16" data-theme={theme} {...props}>
      <circle className="airtame-loading-indicator__dot" cx="12" cy="11" r="5" />
      <circle className="airtame-loading-indicator__dot" cx="32" cy="11" r="5" />
      <circle className="airtame-loading-indicator__dot" cx="52" cy="11" r="5" />
    </svg>
  );
};

LoadingIndicator.displayName = 'LoadingIndicator';
